import { IconsProps } from '@/types/shared'

const DeleteOutlineIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 25 25"
                fill="none"
            >
                <path
                    d="M7.5 21.5C6.95 21.5 6.47917 21.3042 6.0875 20.9125C5.69583 20.5208 5.5 20.05 5.5 19.5V6.5H4.5V4.5H9.5V3.5H15.5V4.5H20.5V6.5H19.5V19.5C19.5 20.05 19.3042 20.5208 18.9125 20.9125C18.5208 21.3042 18.05 21.5 17.5 21.5H7.5ZM17.5 6.5H7.5V19.5H17.5V6.5ZM9.5 17.5H11.5V8.5H9.5V17.5ZM13.5 17.5H15.5V8.5H13.5V17.5Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default DeleteOutlineIcons
